import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {store} from "./store/Store";
import {Auth0Provider} from "@auth0/auth0-react";
import {Provider} from "react-redux";
import {ToastContainer} from 'react-toastify';

import "./assets/css/index.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/styles/font-face.css"
import "./assets/styles/globals.css"
import 'react-toastify/dist/ReactToastify.css';
import {readIncomingBranch} from "./utils/BranchHandoff";

// Must run before the first render: applies the branch id handed over by v2.
readIncomingBranch()

const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Failed to find the root element")
const root = ReactDOM.createRoot(rootElement)

if (!process.env.REACT_APP_AUTH0_DOMAIN) throw new Error("Failed to find the REACT_APP_AUTH0_DOMAIN")
if (!process.env.REACT_APP_AUTH0_CLIENT_ID) throw new Error("Failed to find the REACT_APP_AUTH0_CLIENT_ID")

root.render(
    <Provider store={store}>
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
            cacheLocation="localstorage"
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: process.env.REACT_APP_AUTH0_DISPATCH_AUDIENCE
            }}>
            <ToastContainer/>
            <App/>
        </Auth0Provider>
    </Provider>
);

reportWebVitals();
